// extracted by mini-css-extract-plugin
export default {"impressumWraper":"impressum_impressumWraper__dScd4","impressumContent":"impressum_impressumContent__81lud"};